<template>
  <span>
    <v-layout row>
      <v-flex xs12 class="text-center display-1 mt-10">Our Services</v-flex>
    </v-layout>
    <v-container class="hidden-sm-and-down">
      <v-row dense max-width="400" class="mx-auto">
        <v-col cols="12">
          <v-card color="light-blue lighten-5 mb-5">
            <div class="d-flex flex-no-wrap justify-space-between">
              <div>
                <v-card-title class="headline mt-3">Accounting</v-card-title>
                <v-card-subtitle>
                  <div class="subtitle-1 mt-5">
                    <ul>
                      <li>
                        Bookkeeping for all sales, purchases on a monthly and
                        quarterly basis including reconciliation of all key
                        accounts such as Bank,A/R,A/P.
                      </li>
                      <li>
                        Preparation of HST and other government remittances.
                      </li>
                      <li>
                        Preparation of all Year End statements and
                        reconciliations.
                      </li>
                    </ul>
                  </div>
                </v-card-subtitle>
              </div>

              <v-avatar class="ma-5" size="250" tile>
                <v-img src="@/assets/images/plans/paper-and-tea.jpg"></v-img>
              </v-avatar>
            </div>
          </v-card>
        </v-col>
        <v-col cols="12">
          <v-card color="light-green lighten-5 mb-5">
            <div class="d-flex flex-no-wrap justify-space-between">
              <div>
                <v-card-title class="headline mt-3">Payroll</v-card-title>
                <v-card-subtitle>
                  <div class="subtitle-1 mt-5">
                    <ul>
                      <li>
                        Payroll transactions on a monthly and quarterly basis.
                      </li>
                      <li>
                        Preparation of Payroll Remittances, T4, ROE, WSIB.
                      </li>
                    </ul>
                  </div>
                </v-card-subtitle>
              </div>

              <v-avatar class="ma-5" size="250" tile>
                <v-img src="@/assets/images/plans/paper-and-glass.jpg"></v-img>
              </v-avatar>
            </div>
          </v-card>
        </v-col>
        <v-col cols="12">
          <v-card color="grey lighten-5">
            <div class="d-flex flex-no-wrap justify-space-between">
              <div>
                <v-card-title class="headline mt-3">
                  Personal and Corporate Tax Preparation
                </v-card-title>
                <v-card-subtitle>
                  <div class="subtitle-1 mt-5">
                    <ul>
                      <li>
                        Preparation of personal income tax returns.
                      </li>
                      <li>
                        Preparation of corporate income tax returns.
                      </li>
                    </ul>
                  </div>
                </v-card-subtitle>
              </div>

              <v-avatar class="ma-5" size="250" tile>
                <v-img src="@/assets/images/plans/paper-and-calculator.jpg">
                </v-img>
              </v-avatar>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <div class="hidden-md-and-up mt-5">
      <v-card class="mx-auto mb-5" max-width="400" color="light-blue lighten-5">
        <v-img
          class="white--text align-end"
          height="200px"
          src="@/assets/images/plans/paper-and-tea.jpg"
        >
          <v-card-title>Accounting</v-card-title>
        </v-img>

        <v-card-subtitle>
          <div class="subtitle-1">
            <ul>
              <li>
                Bookkeeping for all sales, purchases on a monthly and quarterly
                basis including reconciliation of all key accounts such as
                Bank,A/R,A/P.
              </li>
              <li>
                Preparation of HST and other government remittances.
              </li>
              <li>
                Preparation of all Year End statements and reconciliations.
              </li>
            </ul>
          </div>
        </v-card-subtitle>
      </v-card>

      <v-card
        class="mx-auto mb-5"
        max-width="400"
        color="light-green lighten-5"
      >
        <v-img
          class="white--text align-end"
          height="200px"
          src="@/assets/images/plans/paper-and-glass.jpg"
        >
          <v-card-title>Payroll</v-card-title>
        </v-img>

        <v-card-subtitle>
          <div class="subtitle-1">
            <ul>
              <li>
                Payroll transactions on a monthly and quarterly basis.
              </li>
              <li>
                Preparation of Payroll Remittances, T4, ROE, WSIB.
              </li>
            </ul>
          </div>
        </v-card-subtitle>
      </v-card>

      <v-card class="mx-auto mb-5" max-width="400" color="grey lighten-5">
        <v-img
          class="white--text align-end"
          height="200px"
          src="@/assets/images/plans/paper-and-calculator.jpg"
        >
          <v-card-title>Personal and Corporate Tax Preparation</v-card-title>
        </v-img>

        <v-card-subtitle>
          <div class="subtitle-1">
            <ul>
              <li>
                Preparation of personal income tax returns.
              </li>
              <li>
                Preparation of corporate income tax returns.
              </li>
            </ul>
          </div>
        </v-card-subtitle>
      </v-card>
    </div>
  </span>
</template>

<script>
export default {
  name: 'HomePlans'
}
</script>

<style scoped>
.headline,
.subtitle-1 {
  word-break: keep-all;
}
</style>
